import { render, staticRenderFns } from "./CodiciIcdIxList.vue?vue&type=template&id=09742cbe"
import script from "./CodiciIcdIxList.vue?vue&type=script&lang=js"
export * from "./CodiciIcdIxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports